import {Calendar, Row, Col, Divider} from "antd";
import React, {useEffect, useState} from "react";
import moment from "moment";
import PropTypes from "prop-types";
import CalendarViewAddModal from "./CalendarViewAddModal";

export function CalendarView(props) {
    const [data, setData] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [modalDate, setModalDate] = useState(null)
    useEffect(() => {
        setData(props.data)
        return () => {
            setData([])
        }
    }, [props])

    const getDayData = (value) => {
        let out = data.filter(item => {
            let isSame = false
            props.dateFields.forEach((field)=>{
                if(field in item) {
                    let date = item[field]
                    if(new moment(date).isSame(value, 'day'))
                        isSame = true
                }
            })
            return isSame
        })

        const sortedArray = out.sort((a, b) => new moment(a.date).format('YYYY-MM-DD HH:MM:SS') -
            new moment(b.date).format('YYYY-MM-DD HH:MM:SS'))

        return sortedArray || [];
    }

    const getMonthData = (value, dataSource) => {
        let month = value.month()
        const monthData = dataSource.filter(v => {
            return new moment(v.date).month() === month
        })
        return monthData.length;
    };

    const monthCellRender = (value) => {
        const num = getMonthData(value, data);
        return num ? (
            <div className="notes-month">
                <section>Total:</section>
                <span>{num}</span>
                <p><a>View All</a></p>
            </div>
        ) : null;
    };

    const dateCellRender = (value) => {
        const listData = getDayData(value)
        return (
            <div style={{width: '100%', height: '100%'}}
                 onClick={()=>{setModalOpen(true); setModalDate(value);}}>
                {listData.map((item, index) => (
                    <li key={item.id}>
                        <a onClick={v => {
                            if (props.onCalendarCellSelect)
                                props.onCalendarCellSelect(item, index, listData)
                        }}>
                            {item.id} {item.name}
                        </a>
                    </li>
                ))}
                {listData.length > 5
                    && (<a>View All</a>) //TODO: EXPAND IT
                }
            </div>
        );
    }

    return (
        <>
            <CalendarViewAddModal title={modalDate ? "Add for "+modalDate.format("MM/DD/YY") : ""}
                                  date={modalDate} open={modalOpen}
                                  onSave={(values)=>{console.log(values)}}
                                  onClose={()=>{setModalOpen(false)}}/>
            <Row style={{minHeight: '80vh'}}>
                <Col span={24}>
                <Calendar dateCellRender={dateCellRender}
                          monthCellRender={monthCellRender}/>
                </Col>
            </Row>
        </>
    )
}

CalendarView.defaultProps = {
    data: [],
    dateFields: ['date', 'reminder_datetime'],
    onCalendarCellSelect: null
}

CalendarView.propTypes = {
    data: PropTypes.array,
    dateFields: PropTypes.array,
    onCalendarCellSelect: PropTypes.func
}

export default CalendarView